import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { get, pause, resume, abort, finish } from '~/actions/work';
import Tag from '~/components/Tag';
import Title from '~/components/Title';
import styleDialog from '~/style/dialog.scss';
import style from './style.scss';

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    return get(this.props.dispatch, this.context.apiClient, this.props.data.id)
      .then(() => this.setState({ loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  renderDialog() {
    const item = this.props.item.toJS();
    const data = item.data || {};
    return (
      <div>
        <Title style={{ marginBottom: '10px' }}>Information</Title>
        <div>Id: #{item.sku}</div>
        <div>Action: <Tag type="action" id={item.actionId} /></div>
        <div>Assignee: <Tag type="user" id={item.userId} /></div>
        {data.containerId && <div>Container: <Tag type="container" id={data.containerId} /></div>}
        {data.orderId && <div>Order: <Tag type="order" id={data.orderId} /></div>}
        <div>Status: {item.finish && 'Finished'}
          {!item.finish && item.paused && 'Paused'}
          {!item.finish && !item.paused && 'In progress'}
        </div>
        <Title style={{ margin: '10px 0' }}>Work log</Title>
        <div>Started: {item.start}</div>
        {item.paused && <div>Paused: {item.start}</div>}
        {item.pauses.map((row, i) => (<div key={i}>
          <div>Paused: {row.from}</div>
          <div>Unpaused: {row.to}</div>
        </div>))}
        {item.finish && <div>Finished: {item.finish}</div>}
        <div className={style.actions}>
          {!!item.finish || !!item.paused || <Button
            label="Finish"
            className={style.green}
            icon="done"
            onClick={() => finish(this.props.dispatch, this.context.apiClient, item.id)}
          />}
          {!!item.finish || !!item.paused || <Button
            label="Pause"
            className={style.yellow}
            icon="pause"
            onClick={() => pause(this.props.dispatch, this.context.apiClient, item.id)}
          />}
          {!!item.finish || !item.paused || <Button
            label="Unpause"
            className={style.green}
            icon="play_arrow"
            onClick={() => resume(this.props.dispatch, this.context.apiClient, item.id)}
          />}
          {!!item.finish || !!item.paused || <Button
            label="Abort"
            className={style.red}
            icon="clear"
            onClick={() => abort(this.props.dispatch, this.context.apiClient, item.id)}
          />}
        </div>
        {item.removed && <div className={style.removed}>REMOVED</div>}
      </div>
    );
  }

  render() {
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            {this.state.loading && 'Loading'}
            {!this.state.loading && !this.props.item && '404'}
            {!this.state.loading && this.props.item && this.renderDialog()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const item = state.getIn(['work', 'items', props.data.id]);
  return { item };
};

export default connect(mapStateToProps)(Dialog);




// WEBPACK FOOTER //
// ./app/dialogs/Work/index.js